import React, { useEffect, useState } from "react";

import DateLabel from "components/date-label.component";
import SearchBar from "components/search-bar.component";

import { getLatestJobs } from "services/employer.service";
import { Job } from "services/types";
import { useNavigate } from "react-router-dom";

function HomePage() {
  const navigate = useNavigate();
  const [latestJobs, setLatestJobs] = useState<Job[]>([])

  useEffect(() => {
    const loadLatestJobs = async () => {
      try {
        const response = await getLatestJobs();
        setLatestJobs(response.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    loadLatestJobs();
  }, []);

  return (
    <React.Fragment>
      <section className="about section" style={{ paddingTop: '60px' }}>
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="section-header text-center" style={{ marginBottom: "2rem" }}>
            <SearchBar
              onSearch={() => {
                navigate("/latest-jobs")
              }}
            />
          </div>

          <div className="section-header text-center mb-3">
            <h2 className="section-title">Manage your hiring from start to finish</h2>
          </div>

          <div className="row g-4 align-items-stretch justify-content-center">

            <div className="col-md-4 col-lg-4" data-aos="fade-up" data-aos-delay="500">
              <a href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=upload-cv`} className="text-decoration-none text-reset">
                <div className="icon-box equal-height">
                  <i className="bi bi-upload"></i>
                  <h3>CV Upload</h3>
                  <p>Your next voyage starts here...</p>
                </div>
              </a>
            </div>

            <div className="col-md-4 col-lg-4" data-aos="fade-up" data-aos-delay="200">
              <a href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=post-a-job`} className="text-decoration-none text-reset">
                <div className="icon-box equal-height">
                  <i className="bi bi-briefcase-fill"></i>
                  <h3>Post a job</h3>
                  <p>Find certified seafarers.​</p>
                </div>
              </a>
            </div>

            <div
              className="col-md-4 col-lg-4"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <a href="/latest-jobs" className="text-decoration-none text-reset">
                <div className="icon-box equal-height">
                  <i className="bi bi-search"></i>
                  <h3>Find a job</h3>
                  <p>Set sail with confidence. Your next job is here...</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="jobs section">
        <div className="container" data-aos="fade-up">

          <div className="section-header text-center mb-4">
            <h2>Latest Job Openings</h2>
            <p>Explore opportunities that match your skills and experience</p>
          </div>

          <div className="row g-4 justify-content-center">
            {latestJobs.map((job) => (
              <div className="col-lg-4 col-md-6" key={job.id}>
                <div className="job-card">
                  <div className="job-header">
                    <i className="bi bi-gear-wide-connected"></i>
                    <h4>{job.post.name}</h4>
                  </div>
                  <p><i className="bi bi-geo-alt"></i> {job.remittances.map(remit => remit.place_of_posting.name).join(',')}</p>
                  <p><i className="bi bi-briefcase"></i> Experience: {job.exp} year(s)</p>
                  <p><i className="bi bi-calendar"></i> Posted: <DateLabel created_at={job.created_at} /></p>
                  <button className="btn btn-indigo">Apply Now</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default HomePage;
